import React from "react";
import { VStack, Select, Heading } from "@chakra-ui/react";
import SettlementTable from "./SettlementTable";
const Settlements = ({merchant,fetchMerchant}) => {
  return (
    <VStack w="full" alignItems={"start"} gap={8}>
      <Heading fontWeight={{base:"400",tablet:"600"}} fontSize={{base:"20px",tablet:"24px"}} fontFamily={"Poppins"}>
        Settlements
      </Heading>
      <VStack alignItems={"start"} gap={4} w="full">
        <Select
          boxShadow={"0px 2px 6px rgba(0,0,0,0.25)"}
          border={"none"}
          w="auto"
          placeholder="Year"
          fontWeight={"medium"}
          fontFamily={"Barlow"}
        >
          <option value="2024">2024</option>
          <option value="2023">2023</option>
          <option value="2022">2022</option>
        </Select>
        <SettlementTable merchant={merchant} fetchMerchant={fetchMerchant} />
      </VStack>
    </VStack>
  );
};

export default Settlements;
